// src/components/Sidebar.jsx
import React from 'react';
import { Link } from 'react-router-dom';
import { FaBars, FaSignOutAlt } from 'react-icons/fa';
import './Sidebar.css'
import { useLocation } from 'react-router-dom';

// Импортируем SVG как URL
import Menu1Url from '../media/imagen/menu1.svg';
import Menu2Url from '../media/imagen/menu2.svg';
import Menu3Url from '../media/imagen/menu3.svg';
import Menu4Url from '../media/imagen/menu4.svg';
import Menu5Url from '../media/imagen/menu5.svg';
import LogoMenu from '../media/imagen/LogoMenu.svg'
import customBurgerIcon from '../media/imagen/custom-burger.svg';
import Girl from '../media/imagen/Girl.svg';


const Sidebar = ({ isCollapsed, toggleCollapse }) => {

  const location = useLocation();

  const menuItems = [
    { id: 1, name: 'Создать тестирование', icon: Menu1Url, path: '/menu1' },
    { id: 2, name: 'Тесты', icon: Menu2Url, path: '/menu2' },
    { id: 3, name: 'Группы', icon: Menu3Url, path: '/menu3' },
    { id: 4, name: 'Результаты', icon: Menu4Url, path: '/menu4' },
    { id: 5, name: 'Методология', icon: Menu5Url, path: '/menu5' },
  ];

  return (
    <aside className={`sidebar ${isCollapsed ? 'collapsed' : ''}`}>
      <div className="sidebar-header">
        {!isCollapsed && <img 
            src={LogoMenu} 
            alt="Навигация" 
        />}
        {/* Кнопка переключения */}
        <button 
          className="toggle-btn"
          onClick={toggleCollapse}
          aria-label={isCollapsed ? "Развернуть меню" : "Свернуть меню"}
        >
          {isCollapsed ? (
            <img 
              src={customBurgerIcon} 
              alt="Меню" 
              className="custom-burger-icon"
            />
          ) : (
            <FaBars className="standard-burger-icon" />
          )}
        </button>
      </div>
      
      <nav className="sidebar-menu">
        {menuItems.map(item => (
          <Link 
            key={item.id} 
            to={item.path} 
            className={`menu-item ${location.pathname === item.path ? 'active' : ''}`}
          >
            <span className="menu-icon">
              <img 
                src={item.icon} 
                alt={item.name} 
                className="svg-icon"
              />
            </span>
            {!isCollapsed && (
              <span className="menu-text">{item.name}</span>
            )}
          </Link>
        ))}
      </nav>
      
      <div className="sidebar-footer">
          {!isCollapsed && <img 
            src={Girl} 
            alt="SoftGirl" 
        />}
      </div>
    </aside>
  );
};

export default Sidebar;